import React, { useRef } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../header';
import Footer from '../footer';
import Sidebar from '../sidebar';
import Megamenu from '../megamenu';
import Mobsidebar from '../mobile-sidebar';
import Carouselhome from '../home/carousel-home';
import Eibfs from '../../images/projects-slider/p1eibfs.webp';
import ScrollToTopButton from '../ScrollButton';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
function Acousticeibfs() {
    const sliderRef = useRef(null);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const goToPrev = () => {
        sliderRef.current.slickPrev();
    };

    const goToNext = () => {
        sliderRef.current.slickNext();
    };

    return (

        <>
            <Helmet>
                <title>About Our EIBFS Dubai Acoustics Project </title>
                <meta name="description" content="Acoustical Interior fit out which include In-house acoustic consultancy & Design, Acoustical wall treatment & ceiling." />
                <meta property="og:title" content="Emirates Institute of Banking & Financial Studies" />
                <meta property="og:description" content="Acoustical Interior fit out which include In-house acoustic consultancy & Design, Acoustical wall treatment & ceiling." />
                <meta property="og:image" content="https://www.acousticalsurfaces.in/images/projects-slider/p1eibfs.webp" />
                <meta property="og:locale" content="en-in" />
                <link rel="canonical" href="https://www.acousticalsurfaces.in/acoustic-projects/project-EIBFS" />
                <link rel="alternate" href="https://www.acousticalsurfaces.in/acoustic-projects/project-EIBFS" hreflang="en-in" />
                <meta name="geo.placename" content="India" />
                <meta http-equiv="content-language" content="IN" />
                <meta name="geo.region" content="india" />
            </Helmet>
            <Header />
            <section className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-3 sidemenu">
                            <Sidebar />
                        </div>
                        <div className="col-sm-9 product-page nopaddding">
                            <div className="container">
                                <div className="megamenu">
                                    <Megamenu />
                                </div>
                            </div>
                            <div className="image-slider pro-content">
                                <div id="caption-slide" className="slider-container">
                                    <div className="slider">
                                        <Slider {...settings} ref={sliderRef}>
                                            <div className="slide">
                                                <img src={Eibfs} className="img-fluid" alt="EIBFS" />
                                            </div>
                                            <div className="slide">
                                                <img src={Eibfs} className="img-fluid" alt="EIBFS" />
                                            </div>
                                            <div className="slide">
                                                <img src={Eibfs} className="img-fluid" alt="EIBFS" />
                                            </div>
                                        </Slider>
                                    </div>
                                    <div className="switch" id="prev" onClick={goToPrev} style={{ backgroundColor: "transparent" }}><span>&#10094;</span></div>
                                    <div className="switch" id="next" onClick={goToNext} style={{ backgroundColor: "transparent" }}><span>&#10095;</span></div>
                                </div>
                            </div>
                            <div className="row pro-content">
                                <div className="col-sm-12 writeup">
                                    <h3>Emirates Institute of Banking & Financial Studies</h3>
                                    <p className="note">Location: Dubai, UAE</p>
                                    <p><strong>About EIBFS Acoustic Project</strong>
                                        <br />Emirates Institute For Banking and Financial Studies (EIBFS) has made quantum leaps by delivering world className education, training and allied services in the area of Banking and Finance at its three campuses strategically located at Sharjah, Abu Dhabi and Dubai.<br />
                                    </p>
                                    <p>
                                        <strong>Our Scope</strong>
                                        <br />Acoustical Interior fit out which include In-house acoustic consultancy & Design, Acoustical wall treatment & ceiling.
                                    </p>
                                    <br />
                                    <hr />
                                </div>
                            </div>
                            <div className="col-sm-12 ourprojects">
                                <h5>OUR PROJECTS</h5>
                                <p style={{ margin: "15px" }}><b>We deliver high-performance acoustic solutions with precision, innovation, and quality craftsmanship.
                                    Explore our recently completed projects that reflect our expertise across diverse spaces.</b></p>
                                <div id="mixedSlider">
                                    <div className="MS-content">
                                        <Carouselhome />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mobsidebar'>
                        <div className="col-sm-12">
                            <div className="container">
                                <div className="row">
                                    <Mobsidebar />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ScrollToTopButton />
            </section>
            <Footer />
        </>
    );
}
export default Acousticeibfs;